import { userLooking } from './user-looking'
import { userOffer } from './user-offer'
import { gameGenres } from './game-genres'
import { gamePlatforms } from './game-platforms'
import { gameEngines } from './game-engines'
import { gameStages } from './game-stages'
import { gameMonetization } from './game-monetization'
import { gameBudget } from './game-budget'
import { gameLookingFor } from './game-looking-for'
import { companySizes } from './company-sizes'

export const useCatalog = () => {
  // TODO: add translations
  return {
    userLooking,
    userOffer,
    gameGenres,
    gamePlatforms,
    gameEngines,
    gameStages,
    gameMonetization,
    gameBudget,
    gameLookingFor,
    companySizes,
  }
}
